<div class="cpp-pagination" *ngIf="pagination.totalResults && pagination.totalPages > 1">
  <div class="cpp-pagination__page-range">
    {{pagination.firstResultCurrentPage}} - {{pagination.lastResultCurrentPage }} {{labels['pagination.word-in-between']}} {{pagination.totalResults}}
  </div>
  <div class="cpp-pagination__navigation">

    <button
      id="go-to-page-first"
      class="cpp-pagination__navigation-item cpp-button cpp-button-pagination"
      [class.cpp-button-pagination--inactive]="pagination.currentPage === 1"
      (click)="goToPage(1)">
        <span class="icon icon--pagination">
        <svg>
          <use xlink:href="#Arrow-First"></use>
        </svg>
      </span>
    </button>

    <button id="go-to-page-{{pagination.currentPage - 2}}"
            class="cpp-pagination__navigation-item cpp-button cpp-button-pagination"
            *ngIf="pagination.currentPage === pagination.totalPages && pagination.totalPages > 2"
            (click)="goToPage(pagination.currentPage - 2)">
      {{pagination.currentPage - 2}}
    </button>


    <button id="go-to-page-{{pagination.currentPage - 1}}"
            class="cpp-pagination__navigation-item cpp-button cpp-button-pagination"
            *ngIf="pagination.currentPage != 1"
            (click)="goToPage(pagination.currentPage - 1)">
      {{pagination.currentPage - 1}}
    </button>

    <button class="cpp-pagination__navigation-item cpp-pagination__navigation-item--current-page cpp-button cpp-button-pagination">
      {{pagination.currentPage }}
    </button>

    <button id="go-to-page-{{pagination.currentPage + 1}}"
            class="cpp-pagination__navigation-item cpp-button cpp-button-pagination"
            *ngIf="pagination.currentPage !== pagination.totalPages"
            (click)="goToPage(pagination.currentPage + 1)">
      {{pagination.currentPage + 1}}
    </button>

    <button id="go-to-page-{{pagination.currentPage + 2}}"
            class="cpp-pagination__navigation-item cpp-button cpp-button-pagination"
            *ngIf="pagination.currentPage === 1 && pagination.totalPages  > 2"
            (click)="goToPage(pagination.currentPage + 2)">
      {{pagination.currentPage + 2 }}
    </button>

    <button id="go-to-page-last"
            class="cpp-pagination__navigation-item cpp-button cpp-button-pagination"
            [class.cpp-button-pagination--inactive]="pagination.currentPage === pagination.totalPages"
            (click)="goToPage(pagination.totalPages)">
      <span class="icon icon--pagination">
         <svg>
          <use xlink:href="#Arrow-Last"></use>
         </svg>
      </span>
    </button>
  </div>
</div>
